import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from 'src/common/utils/api';

export function useDeleteFundDocument() {
  const queryClient = useQueryClient();

  const {
    mutateAsync,
    error,
    isPending: isLoading,
    reset,
  } = useMutation<unknown, Error, { fundId: string; id: string }>({
    mutationFn: ({ fundId, id }) => api.delete(`funds/${fundId}/files/${id}`),
    onSuccess: (_data, { fundId }) => {
      queryClient.invalidateQueries({ queryKey: ['funds', fundId, 'files'] });
    },
  });

  const deleteFundDocument = async (fundId: string, id: string) => {
    return mutateAsync({ fundId, id });
  };

  return {
    deleteFundDocument,
    error,
    isLoading,
    reset,
  };
}
